// extracted by mini-css-extract-plugin
module.exports = {"cardLink":"styles-module--cardLink--32pFU","icon":"styles-module--icon--1MJL4"};